import { render, staticRenderFns } from "./SmsMessage.vue?vue&type=template&id=0a4593e0&scoped=true&"
import script from "./SmsMessage.js?vue&type=script&lang=js&"
export * from "./SmsMessage.js?vue&type=script&lang=js&"
import style0 from "./SmsMessage.vue?vue&type=style&index=0&id=0a4593e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4593e0",
  null
  
)

export default component.exports